<template>
  <div class="index-news-imgBanner">
    <el-carousel height="270px" >
      <el-carousel-item v-for="(item,index) in dataList" :key="index" v-if="index<5">
        <img :src="item.contentImg">
      </el-carousel-item>
    </el-carousel>
  </div>
    
  
</template>
<script>
/**
 * Component newsBanner 页脚组件
 	@author fanjun
  @props data（必选属性前面带＊，非必选项目请备注默认值）
    －*type : String,'1'(默认) - 1、政策法规 2、行业新闻  3、通知公告
	@example
	<newsBanner/>
**/
import { Pagination,Carousel ,CarouselItem } from 'element-ui';
import './index.scss'
export default {
  name: 'newsBanner',
  components:{
    [Pagination.name]:Pagination,
    [Carousel.name]:Carousel,
    [CarouselItem.name]:CarouselItem,
  },
  props:{
    type: {
      type: String,
      required: true,
      default: '1'
    },
  },
  data(){
    return{
      from:{
        postType: '',
        pageNo: 1,
        pageSize: 10,
      },
      dataList:[],
      total:50,
      checkForm:{
        status: '2',//已发布
        contentCategoryId: '',//152-政策法规、153-行业新闻、154-通知公告
        companId: 0,
        indexFlag: "Y",
        pageNum: 1,
        pageSize: 10                                                                   
      },
    }
  },
  created(){
    console.log(this.type)
    if(this.type=='1'){
      this.checkForm.contentCategoryId = '152';
    }else if(this.type=='2'){
      this.checkForm.contentCategoryId = '153';
    }else if(this.type=='3'){
      this.checkForm.contentCategoryId = '154';
    };
    this.getData();//获取数据
  },
  methods: {
    getData:function(){
      this.$api.queryContentList(this.checkForm).then(res=>{
        console.log(res)
        if(res.data.resultCode==200){
          this.dataList = res.data.result;
          this.total = res.data.total;
        }else{
          this.$message.error({ title: res.data.resultDesc });
        }      
      }).catch(err=>{
        console.log(err);
      })
    },
  }
}
</script>

